import {
  getAdvancementSimulation,
  getAdvancementStatus,
  postAdvancementNotification,
  getAdvancementDetail,
} from '@services/advancements-service';
import * as advancementsType from './actionTypes';

export const setShowAdvancementsLoading = (data) => ({
  type: advancementsType.SET_SHOW_LOADING_ADVANCEMENTS,
  payload: data,
});

export const setAdvancementSimulation = (data) => ({
  type: advancementsType.SET_ADVANCEMENT_SIMULATION,
  payload: data,
});

export const setAdvancementStatus = (data) => ({
  type: advancementsType.SET_ADVANCEMENT_STATUS,
  payload: data,
});

export const fetchAdvancementSimulation = (merchantId) => (dispatch) => {
  getAdvancementSimulation(merchantId)
    .then((response) => dispatch(setAdvancementSimulation(response)))
    .catch((error) => console.log(error));
};

export const fetchAdvancementStatus = (advancementStatus) => (dispatch) => {
  getAdvancementStatus(advancementStatus.requestId)
    .then((response) =>
      dispatch(
        setAdvancementStatus({
          ...advancementStatus,
          status: response.status,
          requestCounter: advancementStatus.requestCounter + 1,
        })
      )
    )
    .catch((error) => console.log(error));
};

export const pushAdvanementsNotification = (advancementStatus) => {
  postAdvancementNotification(advancementStatus.requestId)
    .then((response) => console.log(response))
    .catch((error) => console.log(error));
};

export const setAdvancementDetail = (data) => ({
  type: advancementsType.SET_ADVANCEMENT_DETAILS,
  payload: data,
});

export const resetAdvancementDetail = () => ({
  type: advancementsType.RESET_ADVANCEMENT_DETAILS,
});

export const setAdvancementError = (error) => ({
  type: advancementsType.SET_ADVANCEMENT_ERROR,
  payload: error,
});

export const fetchAdvancementDetail =
  (merchantId, transactionId, creditorAccountId) => (dispatch) => {
    dispatch(resetAdvancementDetail());
    dispatch(setAdvancementError(false));

    getAdvancementDetail(merchantId, transactionId, creditorAccountId)
      .then((response) => dispatch(setAdvancementDetail(response)))
      .catch((error) => {
        console.error(error);
        dispatch(setAdvancementError(true));
      });
  };
